/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function ElectoralFinanceCandidateReportingRequirementsInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Electoral Finance"
              description={
                <>
                  <h4>Candidate Reporting Requirements</h4>
                  <br />
                  <p>Section 203(2) of the <em><a href="https://nslegislature.ca/sites/default/files/legc/statutes/elections.pdf"><i><b><u>Elections Act</u></b></i></a></em>:</p>
                  <br />
                  <p>An individual shall apply to be registered under this Section at the earliest of</p>
                  <br />
                  <ul style={{ paddingLeft: "40px" }}>
                  <p>(a) the date on which the official agent of the individual accepts a contribution;</p>
                  <br />
                  <p>(b) the date on which the official agent of the individual accepts a transfer from a registered party or an electoral district association; and</p>
                  <br />
                  <p>(c) the date on which the official agent of the individual incurs an expense in anticipation of an election.</p>
                  <br />
                  </ul>
                  <p>Each official agent of a registered candidate is required to file a financial report no later than March 31 of the year immediately after the calendar year to which the report refers, or 80 days after the individual ceases to be a candidate.</p>
                  <br />
                  <p>During a by-election or general election, a Candidate who is nominated is deemed to be registered.</p>
                  <br />
                  <p>In an election year, the financial report is due with 80 days after the day fixed for return of election. All financial reports filed with the Chief Electoral Officer (CEO) receive a detailed compliance review.&nbsp; It is a statutory obligation of the CEO to be satisfied that expenses reported are properly recorded as election or non-election expenses as defined by the <em><a href="https://nslegislature.ca/sites/default/files/legc/statutes/elections.pdf"><i><b><u>Elections Act</u></b></i></a></em>.&nbsp; Reimbursements for election expenses shall be paid from public funds in accordance with the <em><a href="https://nslegislature.ca/sites/default/files/legc/statutes/elections.pdf"><i><b><u>Elections Act</u></b></i></a>.</em> Candidate Election expenses as originally filed and as adjusted by the CEO are published on the ENS website following the submission and review.</p>
                  <br />
                  <p>The candidate’s official agent is encouraged to read the handbook on the ENS website.&nbsp; The forms are also available on the website.</p>
                  <br />
                  <p><h4>Loans</h4></p>
                  <br />
                  <p>The rules contained in the <em><a href="https://nslegislature.ca/sites/default/files/legc/statutes/elections.pdf"><i><b><u>Elections Act</u></b></i></a></em> regarding loans by registered parties, candidates and electroal district associations are complex.&nbsp; Prior to making or receiving a loan the official agent must understand these rules. There are certain circumstances where a loan may result in a contribution.&nbsp; The official agent of a candidate has an obligation under the <em><a href="https://nslegislature.ca/sites/default/files/legc/statutes/elections.pdf"><i><b><u>Elections Act</u></b></i></a></em> to report loan balances until such time as the loan is drawn down to a zero balance.</p>
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ElectoralFinanceCandidateReportingRequirementsInformation;
